import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Rutas} from '../../../utiles/Rutas';
import {ViafirmaResponse} from '../../../models/ViafirmaModel';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-check-sigafirma',
  templateUrl: './check-sigafirma.component.html',
  styleUrls: ['./check-sigafirma.component.css'],
})
export class CheckSigafirmaComponent implements OnInit {

  show = true;
  listado = false;
  estado: any;
  error: any;
  response: ViafirmaResponse;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private http: HttpClient) {
  }

  ngOnInit(): void {
    if(this.data.tipo !='listado')
      this.checkSigafirma();
    else
    {
      this.estado=this.data.estado;
      this.listadoSigafirma();
    }
    //console.log("Estado: " + this.estado);
    console.log("Response: " + this.response);
    console.log("Data: ", this.data);
  }

  private checkSigafirma(): void {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const json = JSON.stringify({tipo: this.data.tipo, id: this.data.id});
    this.http.post<ViafirmaResponse>(Rutas + 'sigafirma', json, {headers}).subscribe((res) => {
      console.log("Res viafirama:", res)
      this.response = res;
      this.show = false;
    }, (error) => {
      console.log("Error", error);
      this.error = error;
      this.response = null;
      this.show = false;
      }
    );
  }

  private reenviarFirma(i: string, setCode: string, key: string): void {
    this.show=true;
    const email= document.getElementById('email'+i) as HTMLInputElement;
    console.log("Email:"+ email.value);
    console.log("setCode:"+ setCode);

    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const json = JSON.stringify({email: email.value, setCode: setCode, key: key});

    this.http.post<ViafirmaResponse>(Rutas + 'sigafirma/resend', json, {headers}).subscribe( ( res) => {
      Swal.fire('', 'Firma reenviada con éxito', 'success');
      this.response = res;
      this.show = false;
      document.getElementById('btn_cerrar').click();
    }, (error) => {
        Swal.fire('', 'Ha ocurrido un problema, revise los datos y vuelva a intentarlo', 'warning');
        this.response = null;
        this.show = false;
        document.getElementById('btn_cerrar').click();
      }
    );
  }

  private listadoSigafirma(): void {  
    console.log("Estado:"+this.estado);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    var status='RESPONSED';
    if(this.data.estado=='pendiente')
      status='WAITING';

    const json = JSON.stringify({colaborador: this.data.id, estado: status, inicio: "0"});
    this.http.post<ViafirmaResponse>(Rutas + 'sigafirma/procesos', json, {headers}).subscribe((res) => {
      this.response = res;
      this.show = false;
      this.listado=true;
    }, (error) => {
        this.response = null;
        this.show = false;
      }
    );
  }

  getPdf(docurl: string): void {

    const downloadLink = document.createElement('a');
    downloadLink.href = docurl;
    downloadLink.click();
  }
}
